import React, {Component} from 'react';
import DaysBackStoredFilter from '../components/DaysBackStoredFilter';
import RecentTransactionsReport from '../components/RecentTransactionsReport';
import {hasReportsAccess} from '../shared/authFunctions';
import {displayDateRangeStringFromDates} from '../shared/functions';
import FuseTheme from "../global/theme";
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/history';

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
    removeSpacing: {paddingTop: '0'}
};

/**
 * Recent Transactions Reports class for retrieving and displaying summary
 *
 */
class RecentTransactionsReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const recentDaysBack = localStorage.getItem('recent_days_back');
        const daysBack = (recentDaysBack) ? recentDaysBack : '30';
        if (daysBack !== recentDaysBack) {
            localStorage.setItem('recent_days_back', daysBack);
        }
        this.state = {
            daysBack: daysBack,
            errorMessage: null,
            summaryComplete: false,
            system: system,
        };
    }

    /**
     * Handle event props for Table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    handleDaysBackSelect = (days) => {
        this.setState({daysBack: days});
        localStorage.setItem('recent_days_back', days);
    }

    render() {
        const {
            daysBack,
            errorMessage,
            summaryComplete,
            system
        } = this.state;

        // As a Dashboard component, do not display if user lacks access
        if (!hasReportsAccess())  return <div></div>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Recent Transactions</span>;

        const ListDescription = () => {
            const days = (daysBack === '1') ? 'day' : 'days';
            const today = new Date();
            const back = new Date();
            back.setDate(back.getDate() - parseInt(daysBack, 10));
            const dateRange = displayDateRangeStringFromDates(back, today);
            return (
                <span className="list-description hide-print">
                    <p>Recent Transactions display the total payments, credits and net total for the past {daysBack} {days}.</p>
                    <p>({dateRange})</p>
                </span>
            );
        };

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText style={styles.removeSpacing}>
                        <ListDescription/>
                        <DaysBackStoredFilter
                            daysBack={daysBack}
                            onSelectDaysBack={this.handleDaysBackSelect}
                            reportName="recent"
                        />

                        {/* Report Loader, and messaging */}
                        {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }

                        {/* Recent Transactions Report Content */}
                        <RecentTransactionsReport
                            onSummaryComplete={this.handleSummaryComplete}
                            onError={this.handleReportError}
                            system={system}
                            daysBack={daysBack}
                        />

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}

export default RecentTransactionsReports;



// WEBPACK FOOTER //
// ./src/Fuse/Report/RecentTransactionsReports.js